import React from "react";

export function LogoMark({ size = 44 }) {
  return (
    <img
      src="/logo-mark.png"
      alt=""
      aria-hidden="true"
      style={{ width: size, height: "auto" }}
      data-testid="brand-logo-mark"
    />
  );
}

export default function Logo({ size = 44, showText = true }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <LogoMark size={size} />
      {showText && (
        <div className="leading-tight">
          <div className="font-serif font-semibold tracking-wide text-cream" style={{ fontSize: size * 0.42 }}>
            FULL CIRCLE
          </div>
          <div className="font-sans font-medium tracking-[0.18em] uppercase text-teal" style={{ fontSize: Math.max(size * 0.16, 8) }}>
            Immigration &amp; Integration Center
          </div>
        </div>
      )}
    </div>
  );
}
